<template>
  <div class="form-group">
    <template v-if="field.type === 'textfield'">
      <text-field :field="field"></text-field>
    </template>
    <template v-else-if="field.type === 'dropdown'">
      <dropdown :field="field"></dropdown>
    </template>
    <template v-else-if="field.type === 'file'">
      <file :field="field"></file>
    </template>
    <template v-else-if="field.type === 'checkboxes'">
      <checkbox :field="field"></checkbox>
    </template>
    <template v-else-if="field.type === 'radio'">
      <radio :field="field"></radio>
    </template>
    <template v-else-if="field.type === 'textarea'">
      <textarea-field :field="field"></textarea-field>
    </template>
  </div>
</template>

<script>
import Dropdown from "./Dropdown";
import Checkbox from "./Checkbox";
import Radio from "./Radio";
import File from "./File";
import TextField from "./TextField";
import TextareaField from "./Textarea";

export default {
  name: "FormField",
  components: {
    TextareaField,
    TextField,
    Dropdown,
    Checkbox,
    Radio,
    File,
  },
  props: ["field"],
};
</script>
